import { Directive, ElementRef, Input } from '@angular/core';

@Directive({
  selector: '[appShowDuration]',
  standalone: true
})
export class ShowDurationDirective {

  @Input() set appShowDuration(segundos: number | undefined) {
    this.el.nativeElement.textContent = this.formatTime(segundos);
  }

  constructor(private el: ElementRef) {}

  private formatTime(seconds: number | undefined): string {
    if (seconds === undefined) {
      return '';
    }
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);

    if (hours > 0) {
      return `${hours}h ${minutes}min`;
    } else {
      return `${minutes > 0 ? minutes : 1}min`;
    }
  }

}
